<div class="product-view-container">
	<nav class="product-header sticky-top navbar navbar-light bg-light" [ngClass]="{ 'im-dirty': isModified }">
		<span class="navbar-brand">Add City</span>
		<div class="navbar-nav mr-auto"></div>
		<button type="button" class="btn btn-secondary btn-cancel mr-3" [routerLink]="['/regional/cities']">
			<span>Cancel</span>
		</button>
		<button type="button" class="btn btn-primary btn-save" (click)="save()">
			<span>Save</span>
		</button>
		<button mat-icon-button class="btn-close" (click)="back()">
			<mat-icon>close</mat-icon>
		</button>
	</nav>
	<div class="product-container">
		<mat-card>
			<div class="row">
				<div class="col-8">
					<label>City Name</label>
					<div class="input-group mb-3">
						<input [(ngModel)]="city.name" type="text" class="form-control" (input)="dataChanged()">
					</div>

					<label>City Code</label>
					<div class="form-container">
						<input [(ngModel)]="city.code" type="text" class="form-control" (input)="dataChanged()"
							placeholder="Ex: MNL">
						<div class="input-group mb-3">

						</div>
					</div>

					<label>State</label>
					<div class="form-container">
						<select [(ngModel)]="city.stateId" name="stateId" class="custom-select" required="true">
							<option value="0">Select a state</option>
							<option *ngFor="let state of states" value="{{state.id}}">[{{state.code}}] - {{ state.name
								}}</option>
						</select>
					</div>

					<label>Zone</label>
					<select [(ngModel)]="city.zoneId" name="zoneId" class="custom-select" required>
						<option value="0">Select a zone</option>
						<option *ngFor="let zone of zones" value="{{zone.id}}">[{{zone.code}}] - {{ zone.name }}
						</option>
					</select>

					<label>Description</label>
					<div class="input-group mb-3">
						<textarea [(ngModel)]="city.description" class="form-control" rows="5"
							(input)="dataChanged()"></textarea>
					</div>
				</div>
			</div>
		</mat-card>
	</div>
</div>